export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1716_2.857ae2a0.jpg";